import axios, { getEnv } from '../../../../services/api';
import { useQuery } from 'react-query';
import moment from 'moment';
import { TotalFormat } from '../models/acessos.model';
import {
  formattedPerfilUsuarioUser,
  formattedPorteUser,
} from '../models/usuario.model';
import {
  AtendimentosDefault,
  PorteUsers,
  TipoPessoaUsers,
} from '../dashboard.interfaces';

async function fetchData(filter: string): Promise<any> {
  try {
    // @ts-ignore
    const { data } = await axios.get(
      `${await getEnv('REACT_APP_URL_SERVICE')}/v1/usuario/dashboard/${
        filter ? filter : 'total'
      }?dataInicio=2022-11-15&dataFim=2022-12-15`
    );

    return data;
  } catch (error) {
    throw error;
  }
}

async function fetchDataTipoPessoa(): Promise<any> {
  try {
    let urlBase = await getEnv('REACT_APP_URL_SERVICE');
    if (!urlBase.endsWith('/')) {
      urlBase += '/';
    }
    const dataInicio: string = '2022-11-15';
    const dataFim: string = '2022-12-15';
    const tipoPessoas: string[] = ['PESSOA_FISICA', 'PESSOA_JURIDICA', 'TODAS'];

    const promises = tipoPessoas.map((tipoPessoa) => {
      const url = `${urlBase}v1/usuario/dashboard/tipo-pessoa?dataInicio=${dataInicio}&dataFim=${dataFim}&tipoPessoa=${tipoPessoa}`;
      // @ts-ignore
      return axios.get(url);
    });

    const results = await Promise.all(promises);

    const dataPf: AtendimentosDefault = results[0].data;
    const dataPj: AtendimentosDefault = results[1].data;
    const dataTodas: AtendimentosDefault = results[2].data;

    return {
      dataPf,
      dataPj,
      dataTodas,
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function fetchDataPorte(): Promise<any> {
  try {
    let urlBase = await getEnv('REACT_APP_URL_SERVICE');
    if (!urlBase.endsWith('/')) {
      urlBase += '/';
    }
    const dataInicio: string = '2022-11-15';
    const dataFim: string = '2022-12-15';
    const portes: string[] = ['MEI', 'ME', 'EPP', 'OUTROS'];

    const promises = portes.map((p) => {
      const url = `${urlBase}v1/usuario/dashboard/porte?dataInicio=${dataInicio}&dataFim=${dataFim}&porte=${p}`;
      // @ts-ignore
      return axios.get(url);
    });

    const results = await Promise.all(promises);

    const dataMei: AtendimentosDefault = results[0].data;
    const dataMe: AtendimentosDefault = results[1].data;
    const dataEpp: AtendimentosDefault = results[2].data;
    const dataOutros: AtendimentosDefault = results[3].data;

    return {
      dataMei,
      dataMe,
      dataEpp,
      dataOutros,
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
}

const formatTipoPessoa = (data: TipoPessoaUsers) => {
  return formattedPerfilUsuarioUser({
    dataPf: data.dataPf,
    dataPj: data.dataPj,
    dataTodas: data.dataTodas,
  });
};

const formatPorte = (data: PorteUsers) => {
  return formattedPorteUser({
    dataMei: data.dataMei,
    dataMe: data.dataMe,
    dataEpp: data.dataEpp,
    dataOutros: data.dataOutros,
  });
};

const formatTotalUsuarios = (data: any) => {
  return TotalFormat({
    total: {
      name: 'Total de usuários',
      data: data.total,
    },
    atendimentos: data.atendimentos.map((atendimento: any) => ({
      data: moment(atendimento.data).format('DD MMM'),
      total: atendimento.total,
    })),
  });
};

async function getDashTotalUsuarios(filter: string): Promise<any> {
  try {
    if (filter === 'perfil-usuario') {
      const data = await fetchDataTipoPessoa();

      return formatTipoPessoa(data);
    } else if (filter === 'porte') {
      const data = await fetchDataPorte();

      return formatPorte(data);
    } else {
      const data = await fetchData(filter);

      return formatTotalUsuarios(data);
    }
  } catch (error) {
    throw error;
  }
}

export function useTotalDashUsuarios(filter: string) {
  return useQuery(
    ['dashTotalUsuarios', filter],
    () => getDashTotalUsuarios(filter),
    {
      staleTime: 1000 * 5 * 6, // 5 minutos
    }
  );
}
